<template>
  <withTopNav
    :leftText="$t('SaquePw.LeftText')"
    class="text-13"
    :onClickLeft="
      () => {
        $router.back();
      }
    "
    fixed
  >
    <div class="saque flex flex-col h-full">
      <div class="flex-1 flex flex-col overflow-y-auto">
        <LoginPw
          v-if="step === 1"
          @setLoginPassword="setLoginPassword"
          @next="step = 2"
        />
        <SaquePw v-if="step === 2" :loginPassword="loginPassword" @next="step = 3" />
        <SetSuccess v-if="step === 3"></SetSuccess>
      </div>
    </div>
  </withTopNav>
</template>

<script setup lang="ts">
import withTopNav from "@/layouts/withTopNav.vue";
import LoginPw from "./compontents/LoginPw.vue";
import SaquePw from "./compontents/SaquePw.vue";
import SetSuccess from "./compontents/SetSuccess.vue";
const loginPassword = ref("");
const setLoginPassword = (password: string) => {
  loginPassword.value = password;
};

const step = ref<number>(1);
</script>

<style lang="scss" scoped></style>
